<template>
  <div
    id="container"
    class="bg-gray-50"
  >
  
  
    <nav-header>
      <router-view />
    </nav-header>
    <nav-footer />
  </div>
</template>

<script>
import NavHeader from './components/NavHeader';
import NavFooter from './components/NavFooter';


export default {
  components: { NavHeader, NavFooter },
  mounted() {
    
  },
  created() {
    
  }
};
</script>

<style>
#videoContainer {
    /* width is set as 100% here. any width can be specified as per requirement */
    position: absolute;
    width: 100%;
    padding-top: 24%;
    height: 0px;
}

#videoContainerMobile {
    position: absolute;
    width: 100%;
    padding-top: 114%;
    height: 0px;
}


#myVideo {
  min-width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  object-fit: cover;
  display: inline-block;
  vertical-align: top;
  max-width: 100%;
}
</style>